import React from "react";
import PropTypes from "prop-types";
import LinkedHeader from "../generic/LinkedHeader";

import "./detailViewTitle.less";

const DetailViewTitle = props => {
	let {children, ...remainingProps} = props;
	return (
		<LinkedHeader
			className="detail-view-title"
			{...remainingProps}
		>
			{children}
		</LinkedHeader>
	);
};

export default DetailViewTitle;

/*
 We removed the feature type being required because it's only actually required if the catalogLink is supplied.
 There are cases where catalogLink isn't being supplied
 We need to revisit how this component is being used, just not today.
*/
DetailViewTitle.propTypes = {
	title: PropTypes.string,
	featureType: PropTypes.object,
	uniqueId: PropTypes.string.isRequired,
	catalogLink: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/react/views/detailView/DetailViewTitle.jsx